import { lazy } from 'react';

/**
 * Lazy-loaded DateRangeCalendar component export.
 */
export const DateRangeCalendar = lazy(() =>
  import('./date-range-calendar').then((module) => ({
    default: module.DateRangeCalendar,
  })),
);

/**
 * Lazy-loaded SingleDateCalendar component export.
 */
export const SingleDateCalendar = lazy(() =>
  import('./single-date-calendar').then((module) => ({
    default: module.SingleDateCalendar,
  })),
);

export * from './single-date-calendar.types';
export * from './date-range-calendar.types';
